function aboutTimelineSlider() {
  [...document.querySelectorAll('.about-timeline')]?.forEach( slider => {
    new Splide( slider, {
      speed: 1000,
      perPage: 2,
      perMove: 2,
      gap: '1.5rem',
      autoHeight: true,
      lazyload: 'sequential',
      mediaQuery: 'min',
      breakpoints: {
        782: {
          perPage: 4
        },
        1200: {
          perPage: 6,
          perMove: 3,
          drag: false
        },
      }
    } ).mount();
  })
}

document.addEventListener( 'DOMContentLoaded', function() {
  aboutTimelineSlider();
} );
